// extracted by mini-css-extract-plugin
export default {"error":"GlobalStyles_error__xc2XR","blurEffect":"GlobalStyles_blurEffect__xo6PO"};